import moment from 'moment';
import axios from 'axios';

import api from './api';
import { urls } from '../config';
import { ToastMessage } from '../context/ToastContext';
import { handleExceptionMessage } from '../util/handleExceptionAxios';
import { message } from '../util/handleMessages';

export interface IDataReport {
    nameReport: string;
    params: any;
    setLoading?: (loading: boolean) => void;
    addToast(message: Omit<ToastMessage, 'id'>): void;
}

function base64ToArrayBuffer(base64: any) {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export const downloadReport = async ({
    nameReport,
    params,
    setLoading,
    addToast,
}: IDataReport) => {
    try {
        const responseDataToReport = await api.post(
            `reports?nameReport=${nameReport}`,
            {
                nameReport,
                query: params,
            },
        );
        const dataResponse = responseDataToReport.data;

        // Chamada no backend de relatórios
        const baseURLApiReport =
            process.env.REACT_APP_ENVIROMENT === 'local'
                ? urls.apiReport.local
                : urls.apiReport.prod;

        const token = localStorage.getItem('@GESSIS:token');

        const response = await axios.post(
            `${baseURLApiReport}/reports`,
            {
                nameReport: `advogados_${nameReport}`,
                dataset: dataResponse.dataset,
                data: dataResponse.data,
            },
            {
                responseType: 'arraybuffer',
                params,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        );

        let typeArchive = 'pdf';
        if (params.type) {
            typeArchive = params.type;
        }
        const blob = new Blob([response.data], {
            type: `application/${typeArchive}`,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${nameReport}_${moment().format(
            'YYYYMMDDHmmss',
        )}.${typeArchive}`;
        link.click();
    } catch (error) {
        setLoading && setLoading(false);
        const messagesResponse = handleExceptionMessage(error);
        addToast({
            type: 'error',
            title: message.error.downloadPdf,
            description: messagesResponse,
        });
    }
};
